import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import EditBumpForm from "../../components/bump/EditBumpForm";
import axios from "axios";
import { authService } from "../../services/authService";

const EditBump = () => {
    const { productId, bumpId } = useParams<{ productId: string, bumpId: string }>();
    const navigate = useNavigate();
    const [productName, setProductName] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchProductDetails = async () => {
            if (!productId) return;

            try {
                const response = await axios.get(
                    `${import.meta.env.VITE_API_URL}/api/products/${productId}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${authService.getToken()}`
                        }
                    }
                );

                if (response.data && response.data.product) {
                    setProductName(response.data.product.name);
                }
            } catch (error) {
                console.error("Erro ao buscar detalhes do produto:", error);
                setError("Não foi possível carregar os detalhes do produto.");
            } finally {
                setLoading(false);
            }
        };

        fetchProductDetails();
    }, [productId]);

    const handleSuccess = () => {
        // Redirecionar para a página de edição do produto, aba bump
        navigate(`/products/edit/${productId}?tab=bump`);
    };

    const handleError = (error: any) => {
        console.error("Erro ao salvar bump:", error);
    };

    const handleGoBack = () => {
        navigate(`/products/edit/${productId}?tab=bump`);
    };

    return (
        <>
            <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
                <PageBreadcrumb
                    pageTitle="Editar Bump"
                    showBackButton={true}
                    onBack={handleGoBack}
                />

                {loading ? (
                    <div className="flex justify-center items-center h-64">
                        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
                    </div>
                ) : error ? (
                    <div className="bg-red-50 dark:bg-red-900/10 text-red-600 dark:text-red-400 p-3 rounded-lg mb-4">
                        {error}
                    </div>
                ) : (
                    <>
                        <div className="mb-6">
                            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                                Editando Bump: {productName}
                            </p>
                        </div>

                        <EditBumpForm
                            bumpId={bumpId || ''}
                            onSuccess={handleSuccess}
                            onError={handleError}
                        />
                    </>
                )}
            </div>
        </>
    );
};

export default EditBump;
